import React, { useState } from 'react';
import '../CSS/social.css'; // Ensure the path is correct
import profileimg from "../pages/assets/rpx.jpg";

const socialLinks = [
  { name: 'Instagram', icon: 'https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png', url: 'https://instagram.com/ramswaroop03' },
  { name: 'X', icon: 'https://cdn2.iconfinder.com/data/icons/threads-by-instagram/24/x-logo-twitter-new-brand-256.png', url: 'https://x.com/ramswaroop_og' },
  { name: 'LinkedIn', icon: 'https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png', url: 'https://www.linkedin.com/in/ramswarooppatel/' },
  { name: 'Github', icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Octicons-mark-github.svg/600px-Octicons-mark-github.svg.png', url: 'https://github.com/ramswarooppatel/' },
  { name: 'Threads', icon: 'https://cdn4.iconfinder.com/data/icons/threads-by-instagram/128/threads-logo-brand-sign-contained-glyph-circle-256.png', url: 'https://threads.net/@ramswaroop03' },
  { name: 'Reddit', icon: 'https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo_reddit-256.png', url: 'https://www.reddit.com/user/ramswarooppatel/' },
  { name: 'Discord', icon: 'https://cdn0.iconfinder.com/data/icons/social-media-2474/128/discord_message_interaction_logo_communication-256.png', url: 'https://discordapp.com/users/ramswaroop.exe' },
  { name: 'Telegram', icon: 'https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg', url: 'https://t.me/ram_pychunk' },
  { name: 'Pinterest', icon: 'https://upload.wikimedia.org/wikipedia/commons/0/08/Pinterest-logo.png', url: 'https://pinterest.com/ramswarooppatell' },
  { name: 'YouTube', icon: 'https://upload.wikimedia.org/wikipedia/commons/b/b8/YouTube_Logo_2017.svg', url: 'https://youtube.com/@ramswarooppatell' },
  { name: 'Facebook', icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/2021_Facebook_icon.svg/1024px-2021_Facebook_icon.svg.png', url: 'https://www.facebook.com/profile.php?id=61556208497075' },
  { name: 'LeetCode', icon: 'https://assets.leetcode.com/static_assets/public/images/LeetCode_logo_rvs.png', url: 'https://leetcode.com/u/ramswarooppatel/' },
  { name: 'PAY.ME', icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/UPI_logo.svg/374px-UPI_logo.svg.png?20240520070249', url: 'http://paypychunk.unaux.com/?i=2' }
];

const SocialLinks = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleShare = (platform) => {
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent(`Check out RAMSWAROOP PATEL\'s social links! 🚀 Click Here: `);
    let shareUrl;

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${text}`;
        break;
      case 'whatsapp':
        shareUrl = `https://api.whatsapp.com/send?text=${text} ${url}`;
        break;
      default:
        return;
    }

    window.open(shareUrl, '_blank');
  };

  return (
    <div className="container">
      <div className="content-social">
        <div className="profile">
          <img src={profileimg} alt="RAMSWAROOP PATEL" className="profile-img" />
          <h1>RAMSWAROOP PATEL</h1>
        </div>
        <div className="social-links">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img src={link.icon} alt={link.name} />
              <span>{link.name}</span>
            </a>
          ))}
        </div>
        <button className="share-button" onClick={() => setIsModalOpen(true)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="share-icon">
            <circle cx="18" cy="5" r="3"></circle>
            <circle cx="6" cy="12" r="3"></circle>
            <circle cx="18" cy="19" r="3"></circle>
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
          </svg>
          Share This Page
        </button>
        <a href="http://tt.rpx.unaux.com">TT</a>
      </div>

      {isModalOpen && (
        <div className="modal" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setIsModalOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <h2>Share This Page</h2>
            <div className="share-buttons">
              <button className="share-facebook" onClick={() => handleShare('facebook')}>Facebook</button>
              <button className="share-twitter" onClick={() => handleShare('twitter')}>Twitter</button>
              <button className="share-linkedin" onClick={() => handleShare('linkedin')}>LinkedIn</button>
              <button className="share-whatsapp" onClick={() => handleShare('whatsapp')}>WhatsApp</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialLinks;